module.exports = __webpack_public_path__ + "static/media/Somod_logo.7f0dc450.png";